import script from "./AppHome.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHome.vue?vue&type=script&setup=true&lang=js"

import "./AppHome.vue?vue&type=style&index=0&id=6a726932&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a726932"]])

export default __exports__